import '@babel/polyfill';

(async () => {
  await import(/* webpackChunkName: "locations-main" */ '../pages/locations/index');
})();
